
import Camera from '@/views/Camera.vue';
import { computed, Ref } from 'vue';
import store from '@/store';

export default {
  name: 'Embed',
  components: {
    Camera,
  },
  setup(): { isLoading: Ref<boolean> } {
    const isLoading: Ref<boolean> = computed(() => store.getters['ui/isLoading']);

    return {
      isLoading,
    };
  },
};
